import { useState, useEffect } from 'react';
import { useParams } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import { actions as ppcActions } from '../../reducers/ppc.reducer';
import Button from '../common/Button.react';
import AddImage from '../common/assets/add-image/AddImage.button';
import ReCrop from '../common/assets/add-image/ReCrop.button';
var SlideBG = function SlideBG(_ref) {
  var slideID = _ref._id,
    image = _ref.image;
  var dispatch = useDispatch();
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("h3", {
    style: {
      marginTop: 20
    }
  }, "Background"), !image && /*#__PURE__*/React.createElement("div", {
    className: "slide__buttons"
  }, /*#__PURE__*/React.createElement(AddImage, {
    blobType: "ppcHomeSlider",
    onCrop: function onCrop(data) {
      dispatch({
        type: ppcActions.construxHomeSlider,
        payload: {
          formData: {
            slideID: slideID,
            blobType: data.blobType,
            assetID: data.assetID,
            crop: data.crop,
            apiID: 'slide-update'
          },
          method: 'post',
          route: 'background'
        }
      });
    }
  })), image && /*#__PURE__*/React.createElement("div", {
    className: "slide__buttons"
  }, /*#__PURE__*/React.createElement(Button, {
    label: "Delete",
    type: "delete",
    requireConfirmation: true,
    icon: "lock-icon@3x.png",
    onClick: function onClick() {
      dispatch({
        type: ppcActions.construxHomeSlider,
        payload: {
          formData: {
            slideID: slideID,
            apiID: 'slide-update'
          },
          method: 'delete',
          route: 'background'
        }
      });
    },
    permission: "edit-sections"
  })));
};
export default SlideBG;